/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  ABOUT_GENESYS_BOT_CONNECTOR:
    'https://help.mypurecloud.com/articles/about-genesys-bot-connector/',
  GENESYS_API_LINK: 'https://developer.genesys.cloud/platform/api/',
  ASSISTANT_GENESYS_CONFIG_INSTRUCTIONS:
    'https://github.ibm.com/watson-engagement-advisor/haa-integration/wiki/Creating-the-Genesys-BotConnector-Integration',
  learnMoreRequestURL: generateDocsUrl('/?topic=assistant-release-notes'),
  learnMoreRequestUrlNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-watson-assistant-release-notes'
  )
};
